import React from 'react';
import { withBaseIcon } from 'react-icons-kit';
import { iosMoon } from 'react-icons-kit/ionicons/iosMoon';
import { adjustBrightness } from 'react-icons-kit/typicons/adjustBrightness';
import { ic_delete } from 'react-icons-kit/md/ic_delete';
import { arrows_slim_left } from 'react-icons-kit/linea/arrows_slim_left';
import { ic_filter_list } from 'react-icons-kit/md/ic_filter_list';
import { ic_clear } from 'react-icons-kit/md/ic_clear';
import { arrowUnsorted } from 'react-icons-kit/typicons/arrowUnsorted';
import { arrowSortedUp } from 'react-icons-kit/typicons/arrowSortedUp';
import { arrowSortedDown } from 'react-icons-kit/typicons/arrowSortedDown';
import { ic_error } from 'react-icons-kit/md/ic_error';
import { ic_fiber_manual_record } from 'react-icons-kit/md/ic_fiber_manual_record';
import { basic_magnifier } from 'react-icons-kit/linea/basic_magnifier';
import { ic_keyboard_arrow_down } from 'react-icons-kit/md/ic_keyboard_arrow_down';
import { ic_keyboard_arrow_right } from 'react-icons-kit/md/ic_keyboard_arrow_right'
import { ic_keyboard_arrow_up } from 'react-icons-kit/md/ic_keyboard_arrow_up';
import { lineArrowLeft } from 'react-icons-kit/oct/lineArrowLeft';
import { lineArrowRight } from 'react-icons-kit/oct/lineArrowRight';
import { eye } from 'react-icons-kit/entypo/eye';
import { withLine } from 'react-icons-kit/entypo/withLine';
import { ic_info_outline } from 'react-icons-kit/md/ic_info_outline'
import { ic_done } from 'react-icons-kit/md/ic_done';
import { ic_help_outline } from 'react-icons-kit/md/ic_help_outline';
import { ic_translate } from 'react-icons-kit/md/ic_translate';
import { ic_cached } from 'react-icons-kit/md/ic_cached';
import { checkmarkCircled } from 'react-icons-kit/ionicons/checkmarkCircled';
import { androidRadioButtonOff } from 'react-icons-kit/ionicons/androidRadioButtonOff';
import { lifebuoy } from 'react-icons-kit/icomoon/lifebuoy';
import { ic_content_copy_outline } from 'react-icons-kit/md/ic_content_copy_outline';
import { ic_menu } from 'react-icons-kit/md/ic_menu';
import { weatherSunny } from 'react-icons-kit/typicons/weatherSunny';
import { weatherNight } from 'react-icons-kit/typicons/weatherNight';

const IconContainer = withBaseIcon({ size: 30 });
interface ArrowProps {
    onClick?: Function;
}

export const IosMoon = () => <IconContainer icon={iosMoon} />;
export const IosSunny = () => <IconContainer icon={adjustBrightness} />;
export const Delete = () => <IconContainer icon={ic_delete} className="text-orange" />;
export const BackArrow = () => <IconContainer icon={arrows_slim_left} size={18} />;
export const NextArrow: React.FC<ArrowProps> = ({ onClick }) => (
    <IconContainer icon={lineArrowRight} size={18} onClick={onClick} />
);
export const PrevArrow: React.FC<ArrowProps> = ({ onClick }) => (
    <IconContainer icon={lineArrowLeft} size={18} onClick={onClick} />
);
export const FilterIcon = () => <IconContainer icon={ic_filter_list} size={20} />
export const Clear = () => <IconContainer icon={ic_clear} size={18} />
export const Clear_Large = () => <IconContainer icon={ic_clear} size={24} />
export const SortingArrows = () => <IconContainer icon={arrowUnsorted} size={18} className="text-dark-green" />
export const SortedUp = () => <IconContainer icon={arrowSortedUp} size={18} className="text-bright-green" />
export const SortedDown = () => <IconContainer icon={arrowSortedDown} size={18} className="text-bright-green" />
export const NavBarSortedUp = () => <IconContainer icon={arrowSortedUp} size={18} className="text-black dark:text-white" />
export const NavBarSortedDown = () => <IconContainer icon={arrowSortedDown} size={18} className="text-black dark:text-white" />
export const LogsFilterSortedUp = () => <IconContainer icon={arrowSortedUp} size={18} className="text-medium-gray hover:text-status-green" />
export const LogsFilterSortedDown = () => <IconContainer icon={arrowSortedDown} size={18} className="text-medium-gray hover:text-status-green" />
export const ProfileDropdown = () => <IconContainer icon={arrowSortedDown} size={18} className="text-white" />
export const AttentionIcon = () => <IconContainer icon={ic_error} size={18} className="text-orange" />
export const HealthyIcon = () => <IconContainer icon={ic_fiber_manual_record} size={22} className="text-status-green" />
export const SearchIcon = () => <IconContainer icon={basic_magnifier} size={18} />;
export const ArrowUp = () => <IconContainer icon={ic_keyboard_arrow_up} size={24} className="text-dark-green" />
export const ArrowDown = () => <IconContainer icon={ic_keyboard_arrow_down} size={24} className="text-dark-green" />
export const ArrowRight = () => <IconContainer icon={ic_keyboard_arrow_right} size={24} className="text-dark-green" />
export const ArrowRightGray = () => <IconContainer icon={ic_keyboard_arrow_right} size={24} className="text-medium-gray" />
export const ShowString = () => <IconContainer icon={eye} size={18} className="text-off-black dark:text-white" />
export const HideString = () => <IconContainer icon={withLine} size={18} className="text-off-black dark:text-white" />
export const ToolTipIcon = () => <IconContainer icon={ic_info_outline} size={18} className={"text-medium-gray hover:text-status-green"} />
export const Checkmark = () => <IconContainer icon={ic_done} size={18} className="text-status-green" />
export const HelpIcon = ({ helpMenu }: { helpMenu: boolean }) => <IconContainer icon={ic_help_outline} size={18} className={helpMenu ? "text-white" : "text-neutral-gray-400"} />
export const TranslateIcon = () => <IconContainer icon={ic_translate} size={18} />
export const RefreshSpinner = () =>
    <IconContainer
        icon={ic_cached}
        size={18}
        className="text-medium-gray hover:text-dark-green cursor-pointer m-auto pb-1" // Add m-auto to center the icon
        style={{ display: 'block' }} // Ensure it's a block element
    />
export const CurrentStep = () => <IconContainer icon={androidRadioButtonOff} size={18} className="text-status-green" />
export const UnselectedStep = () => <IconContainer icon={androidRadioButtonOff} size={18} className="text-medium-gray" />
export const CompletedStep = () => <IconContainer icon={checkmarkCircled} size={18} className="text-status-green" />
export const HelpCenterIcon = () => <IconContainer icon={lifebuoy} size={18} className="text-dark-green dark:text-dark-green-100 mx-1 transition-colors duration-300" />
export const CopyToClipboard = () => <IconContainer icon={ic_content_copy_outline} size={18} className="cursor-pointer text-off-black dark:text-white" />
export const LightMode = () => <IconContainer icon={weatherSunny} size={24} className="cursor-pointer text-neutral-gray-400" />
export const DarkMode = () => <IconContainer icon={weatherNight} size={24} className="cursor-pointer text-neutral-gray-400" />
